import * as React from "react";
import { INews } from "src/type/news";
import { Chip, WithStyles, Theme, createStyles } from "@material-ui/core";
import { replaceNameCategory } from "../CategoriesFilter/helpers";

const styles = (t: Theme) => createStyles({
    chip: {
        margin: '4px',
        fontSize: '0.75rem',
        height: '26px'
    }
});

  
interface IProps extends WithStyles<typeof styles>{
    news: INews;
    mapName: any;
}

export const NewsTags: React.SFC<IProps> = (props) => {
  return (
    <>
        {props.news.category_principale &&
            props.news.category_principale.split(",").map(c => 
                props.mapName.get(c) !== undefined ? <Chip key={`category-principale-${c}`}  label={replaceNameCategory(props.mapName.get(c))} className={props.classes.chip} /> : ''
            )
        }
        {props.news.category_produit &&
            props.news.category_produit.split(",").map(c => 
                props.mapName.get(c) !== undefined ? <Chip key={`category-produit-${c}`} label={replaceNameCategory(props.mapName.get(c))} className={props.classes.chip}/> : ''
            )
        }
        {props.news.category_actu &&
            props.news.category_actu.split(",").map(c => 
                props.mapName.get(c) !== undefined ? <Chip key={`category-actu-${c}`} label={replaceNameCategory(props.mapName.get(c))} className={props.classes.chip}/> : ''
            )
        }
        {props.news.category_actu_nuage &&
            props.news.category_actu_nuage.split(",").map(c => 
                props.mapName.get(c) !== undefined ? <Chip key={`category-actu-nuage-${c}`} label={replaceNameCategory(props.mapName.get(c))} className={props.classes.chip}/> : ''
            )
        }
    </>
  )
};



// WEBPACK FOOTER //
// ./src/shared/News/NewsTags.tsx